var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-center align-items-center min-vh-100",
          },
          [_c("fco-spinner")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center align-items-center min-vh-100",
      },
      [
        _vm.hasAuthError
          ? _c(
              "div",
              {
                staticClass:
                  "errorMessage d-flex flex-column justify-content-center align-items-center text-center",
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "mb-3",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.fcoM(
                          "rs.authentication.failed",
                          "Authentication failed. Please try again."
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: _vm.punchout,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.fcoM("common.tryAgain", "Try again")) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }